<template>
	<div class="modal-container modalVersionDeployLogs">
		<div class="modal-header">
			{{ messageTitle }}
		</div>
		<div class="modal-body">
			<div v-html="messageBody"></div>
		</div>
		<div class="modal-footer">
			<button
				class="button-save"
				@click="close()"
			>
				Accept
			</button>
		</div>
	</div>
</template>

<script>
	import $modal from '@core/services/modal';

	export default {
		name: 'modalVersionDeployLogs',
		props: ['modal'],
		data() {
			return {
				messageTitle: '',
				messageBody: '',
			};
		},
		computed: {},
		created() {
			this.messageTitle = this.modal.passedData.messageTitle;
			this.messageBody = this.modal.passedData.messageBody;
		},
		mounted() {},
		methods: {
			close() {
				$modal.close(this.additionalData);
			},
			cancel() {
				if (typeof this.modal.passedData.cancelFunction == 'function') {
					this.modal.passedData.cancelFunction();
				}
				$modal.cancel();
			},
		},
		components: {},
	};
</script>
<style></style>
